import {
  HelpContent,
  HelpContentSearchResult,
  HelpMediaUploadResponse,
} from '@easy-genomics/shared-lib/src/app/types/easy-genomics/help-content';
import { httpClient } from '@/lib/api/client';

class HelpContentModule {
  async list(): Promise<HelpContent[]> {
    const res = await httpClient.call<HelpContent[]>('GET', '/help-content/list-help-contents');

    if (!res) {
      throw new Error('Failed to retrieve list of help contents');
    }

    return res;
  }

  async read(tabId: string): Promise<HelpContent> {
    const res = await httpClient.call<HelpContent>('GET', `/help-content/read-help-content/${tabId}`);

    if (!res) {
      throw new Error('Failed to retrieve help content');
    }

    return res;
  }

  async create(body: {
    TabName: string;
    Content: string;
    SortOrder?: number;
    MediaReferences?: string[];
  }): Promise<HelpContent> {
    const res = await httpClient.call<HelpContent>('POST', '/help-content/create-help-content', body);

    if (!res) {
      throw new Error('Failed to create help content');
    }

    return res;
  }

  async update(
    tabId: string,
    body: Partial<{ TabName: string; Content: string; SortOrder: number; MediaReferences: string[] }>,
  ): Promise<HelpContent> {
    const res = await httpClient.call<HelpContent>('PUT', `/help-content/update-help-content/${tabId}`, body);

    if (!res) {
      throw new Error('Failed to update help content');
    }

    return res;
  }

  async remove(tabId: string): Promise<void> {
    const res = await httpClient.call<void>('DELETE', `/help-content/delete-help-content/${tabId}`);

    if (!res) {
      throw new Error('Failed to delete help content');
    }

    return res;
  }

  async search(query: string): Promise<HelpContentSearchResult[]> {
    const res = await httpClient.call<HelpContentSearchResult[]>('POST', '/help-content/request-help-content-search', {
      Query: query,
    });

    if (!res) {
      throw new Error('Failed to search help contents');
    }

    return res;
  }

  async requestMediaUpload(body: {
    TabId: string;
    FileName: string;
    FileSize: number;
    ContentType: string;
  }): Promise<HelpMediaUploadResponse> {
    const res = await httpClient.call<HelpMediaUploadResponse>('POST', '/help-content/request-help-media-upload', body);

    if (!res) {
      throw new Error('Failed to request media upload URL');
    }

    return res;
  }

  async reorder(items: { TabId: string; SortOrder: number }[]): Promise<void> {
    const res = await httpClient.call<void>('POST', '/help-content/request-help-content-reorder', { Items: items });

    if (!res) {
      throw new Error('Failed to reorder help contents');
    }

    return res;
  }
}

export default HelpContentModule;
